import { useQuery } from "@tanstack/react-query";

import { orpc } from "@/client";

export function PessoasNavBadge() {
	const { data } = useQuery(orpc.people.review.queryOptions());

	if (data === undefined || data.badge === 0) {
		return null;
	}

	return (
		<span className="ml-auto rounded-full bg-destructive px-1.5 py-0.5 text-xs font-medium text-destructive-foreground">
			{data.badge}
		</span>
	);
}
